"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.orangeTheme = void 0;
var chroma_js_1 = require("chroma-js");
var shared_1 = require("./shared");
exports.orangeTheme = __assign(__assign({}, shared_1.sharedTheme), { font: "Inter", primaryColor: "#F47820", dm__primaryColor: "#F47820", secondaryColor: (0, chroma_js_1.blend)("#F47820", "#BDBDBD", "multiply").hex(), dm__secondaryColor: (0, chroma_js_1.blend)("#F47820", "#BDBDBD", "multiply").hex(), headerColor: "#111111", background: "#FFFFFF", dm__background: "#4A4A4A", colorBackground: "#F47820", dm__colorBackground: "#F47820", cardBackgroundColor: shared_1.sharedTheme.gray5, dm__cardBackgroundColor: shared_1.sharedTheme.gray2, dm__primaryButtonDisabled: shared_1.sharedTheme.gray2, textColor: "#000", dm__textColor: "#FFF", labelListValueColor: "#F47820" });
exports.default = exports.orangeTheme;
